import { render, staticRenderFns } from "./LabelContractsGroupedContractsReadOnlyPanel.vue?vue&type=template&id=a2301eb4"
import script from "./LabelContractsGroupedContractsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsGroupedContractsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports